import { render, staticRenderFns } from "./DeclarationStat.vue?vue&type=template&id=837503ea&scoped=true&"
import script from "./DeclarationStat.vue?vue&type=script&lang=js&"
export * from "./DeclarationStat.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationStat.vue?vue&type=style&index=0&id=837503ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837503ea",
  null
  
)

export default component.exports